<template>
  <section class="feature" :class="'step-'+step">
    <div class="container">
      <a-typography-title :level="1">
        {{ title }}
      </a-typography-title>
      <a-row :gutter="[40,20]">
        <a-col v-for="item in expand.list" :xs="24" :lg="8" :key="item.title">
          <div class="item">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <template v-if="item?.textArray?.length">
              <a-typography-paragraph v-for="text in item.textArray" :key="text">
                {{ text }}
              </a-typography-paragraph>
            </template>
            <template v-else>
              <a-typography-text>
                {{ item.text }}
              </a-typography-text>
            </template>
          </div>
        </a-col>
      </a-row>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'"> -->
      <!-- <a-button type="link" class="button_n_2"
                  @click="clickToStore()">
          立即注册体验
        </a-button> -->
      <!--<a-button type="link" class="button_1"-->
      <!--          @click="$Store.Page().openModal('modalFormCollection', 'deployment')">-->
      <!--  预约私有化部署-->
      <!--</a-button>-->
      <!-- </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";
export default {
  name: "product_feature",
  props: ["step", "title"],
  data(): DataInterface {
    return {
      expand: {
        list: [],
        advantage: [
          {
            title: "全链路数据安全",
            text: "通过国密算法加密存储,支持GDPR/等保2.0合规,数据不出企业内网",
          },
          {
            title: "100%企业专属",
            text: "支持形象/知识库/交互逻辑深度定制,独立部署专属数字人系统",
          },
          {
            title: "多模式灵活部署",
            text: "支持本地服务器/私有云/混合云部署,满足不同规模企业需求",
          },
        ],
        framework: [
          {
            title: "应用层",
            text: "数字人交互界面",
          },
          {
            title: "100%能力层",
            text: "Al大模型+RAG+Agent引擎",
          },
          {
            title: "基础设施层",
            text: "私有化部署环境",
          },
        ],
        deploy: [
          {
            title: "轻量版",
            textArray: ["单服务器部署", "支持100并发会话", "适合中小企业"],
          },
          {
            title: "企业版",
            textArray: ["分布式集群部署", "支持万级并发会话", "适合大型集团"],
          },
          {
            title: "混合云版",
            textArray: ["本地+云端协同", "弹性扩展资源", "适合跨国企业"],
          },
        ],
      },
    };
  },
  mounted() {
    this.expand.list = this.expand[this.step];
  },
  methods: {
    /**
     * 点击去商城
     */
    clickToStore(): void {
      // location.href = $Config.Href.cloud;
      open($Config.Href.cloud);
    },

    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloudDemo;
      open($Config.Href.cloudDemo);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/productPrivateAidigitalHuman/";

@steps: advantage, framework, deploy; // 添加你需要的所有类型

// 生成动态样式
.generate-styles() {
  .loop-steps(@list, @i: 1) when (@i <= length(@list)) {
    @step: extract(@list, @i);

    .step-@{step} {
      .ant-col {
        .loop-items(@j) when (@j <= 3) {
          &:nth-child(@{j}) .item::before {
            // & when (@step = framework) {
            //   .bg("@{image}@{step}.png"); // framework特殊处理
            // }
            // & when not (@step = framework) {
            //   .bg("@{image}@{step}_@{j}.png"); // 其他正常处理
            // }
            .bg("@{image}@{step}_@{j}.png");
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
          .loop-items(@j + 1);
        }
        .loop-items(1);
      }
    }
    .loop-steps(@list, @i + 1);
  }
  .loop-steps(@steps);
}
.generate-styles();

.feature {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_9;

  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    text-align: center;
  }
}

h1.ant-typography {
  position: relative;
  margin: 20px 0 20px;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;

  .ant-col {
    @w: 100px;

    .item {
      position: relative;
      width: 100%;
      max-width: 375px;
      height: max-content;
      padding: 20px 30px;
      margin: 0 auto;
      background-color: @color_white;
      border-radius: 6px;
      .shadow(0 0 10px fade(@color_black, 10));

      &:hover {
        &::before {
          .transform(scale(1.1));
        }
      }

      &::before {
        @h: 100px;
        content: "";
        display: block;
        width: @w;
        height: @h;
        margin: 0 auto;
        // .bg("@{image}worth_icon.png", @w*3, @h);
        .transition(transform 1s);
      }

      h5.ant-typography {
        margin: @margin_mo 0 @margin_mo;
        .font(center, @text_big, @color_12, @text_big, true);
      }

      div.ant-typography {
        margin: @margin_mo 0 0;
        .font(center, @text+@line, @color_3, @text);
        .wordBreak();
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .feature {
    .container {
      padding: @space_mo 0;
    }
  }

  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }

  .ant-row {
    margin: @margin_mo 0 0;

    .ant-col {
      .item {
        height: auto;
      }
    }
  }
}
</style>